import React, { useState } from "react";

const listData = [
  {
    title: "Spine Surgery",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "spineSurgery",
  },
  {
    title: "Psychological Therapy",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "psychologicalTherapy",
  },
  {
    title: "Physical Therapy",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "physicalTherapy",
  },
  {
    title: "Brace Support",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "branchSupport",
  },
  {
    title: "Massage Therapy",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "massageTherapy",
  },
  {
    title: "Spinal Cord Stimulator Trial",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "spinalCordStimulator",
  },
  {
    title: "Chiropractic Care",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "chiropracticCare",
  },
  {
    title: "Acupuncture",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "acupuncture",
  },
  {
    title: "Medication",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "medication",
  },
  {
    title: "Spinal Cord Stimulator Implant",
    options: ["Helped Pain", "Worsened", "No Change"],
    name: "spinalCordStimulatorImplant",
  },
];

export const PainHistory = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [openIndex, setOpenIndex] = useState(null);
  const [haveDisabilityForPain, setHaveDisabilityForPain] = useState("No");

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    setPatientMedicationInfo({
      ...patientMedicationInfo,
      [name]: value,
    });
  };
  return (
    <>
      <div className="mb-5 w-full flex flex-col justify-between items-start gap-5 bg-white p-5 rounded shadow-sm">
        <div className="my-2 flex flex-col gap-8 p-6  border-b border-[#d4d4d4]">
          <p className="font-mainFont font-[600] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] text-white">
            Have you had any other treatments for pain?
          </p>
          <div className="flex justify-start items-center gap-4">
            <button
              onClick={() => {
                setHaveDisabilityForPain("Yes");
                // setPatientMedicationInfo({
                //   ...patientMedicationInfo,
                //   takingBloodThinner: "Yes",
                // });
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  hadTeatmentForPain: "Yes",
                });
              }}
              className={`text-[#333333] ${
                patientMedicationInfo.hadTeatmentForPain === "Yes"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }  px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper`}
            >
              Yes
            </button>
            <button
              onClick={() => {
                setHaveDisabilityForPain("No");
                setPatientMedicationInfo({
                  ...patientMedicationInfo,
                  hadTeatmentForPain: "No",
                });
              }}
              className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                patientMedicationInfo.hadTeatmentForPain === "No"
                  ? "text-white BTNGradientBg"
                  : "text-black bg-white"
              }`}
            >
              No
            </button>
          </div>
        </div>
        {patientMedicationInfo.hadTeatmentForPain === "Yes" && (
          <div className="flex flex-col justify-between items-start w-full gap-5">
            <div className="flex flex-col gap-5 2xl:w-[50%] xl:w-[50%] lg:w-[50%] md:w-[50%] w-[100%] ">
              {listData.map((list, index) => (
                <AccordionItem
                  key={index}
                  index={index}
                  title={list.title}
                  options={list.options}
                  isOpen={openIndex === index}
                  onToggle={handleToggle}
                  name={list.name}
                  handleOnChange={handleOnChange}
                  patientMedicationInfo={patientMedicationInfo}
                />
              ))}
            </div>

            <div className="2xl:w-[50%] xl:w-[50%] lg:w-[50%] md:w-[50%] w-[100%] my-2 flex justify-end">
              <div className="2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[60%] w-[100%] flex flex-col justify-start items-start gap-3">
                <label className="font-[500] 2xl:text-[1.2dvw] xl:text-[1.2dvw] lg:text-[1.2dvw] md:text-[1.2dvw] text-[3.5vw] text-[#333333]">
                  Others
                </label>
                <input
                  className=" w-full px-6 py-3 rounded-full border-2 outline-none border-[#d4d4d4] font-mainFont font-[500] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] placeholder:text-[#333333]/50 text-mainColor bg-[#f0f0f0] "
                  placeholder="Enter Therapy"
                  onChange={(e) => {
                    setPatientMedicationInfo({
                      ...patientMedicationInfo,
                      PTHOther: e.target.value,
                    });
                  }}
                  value={patientMedicationInfo.PTHOther}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const AccordionItem = ({
  title,
  options,
  isOpen,
  index,
  onToggle,
  name,
  handleOnChange,
  patientMedicationInfo,
}) => {
  return (
    <>
      <div className="bg-transparent">
        <button
          style={{
            background: isOpen ? "#24518B" : "transparent",
            color: isOpen ? "#fff" : "#0C0544",
          }}
          className={`flex flex-col justify-start items-start w-full gap-4 py-4 border-b border-[#0A1E44] ${
            isOpen ? "px-8 rounded-full border-b-0" : "px-4 rounded-none "
          } text-left  focus:outline-none  transition-all duration-300 ease-linear`}
          onClick={() => onToggle(index)}
        >
          <div className="flex justify-between items-center w-full">
            <span
              className={`font-[700] font-mainFont 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[2.3vw] text-[3.5vw] ${
                isOpen ? "text-[#fff]" : "text-[#333333]"
              }`}
            >
              {title}
            </span>

            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={`w-5 h-5 transition-transform duration-500 ${
                isOpen ? "transform rotate-180" : ""
              }`}
            >
              <path
                d="M13.9999 3.33326L1.99994 3.33326C1.87845 3.33364 1.75936 3.36715 1.65549 3.43018C1.55163 3.49321 1.46692 3.58337 1.41048 3.69097C1.35404 3.79856 1.32802 3.9195 1.33521 4.04079C1.3424 4.16207 1.38253 4.27909 1.45128 4.37926L7.45128 13.0459C7.69994 13.4053 8.29861 13.4053 8.54794 13.0459L14.5479 4.37926C14.6174 4.2793 14.6581 4.16222 14.6657 4.04073C14.6733 3.91925 14.6474 3.79801 14.5909 3.69019C14.5344 3.58237 14.4495 3.49209 14.3453 3.42917C14.2411 3.36624 14.1217 3.33307 13.9999 3.33326Z"
                fill={isOpen ? "white" : "#0A1E44"}
              />
            </svg>
          </div>
        </button>
        <div
          className={`overflow-hidden transition-all duration-500 ease-linear ${
            isOpen ? "max-h-96" : "max-h-0"
          }`}
        >
          <div className="p-6 bg-transparent flex flex-wrap  gap-4">
            {options.map((cur, id) => (
              <>
                <div className="flex justify-start items-center gap-3 border border-[#d4d4d4] px-3 py-1 rounded-full">
                  <input
                    value={cur}
                    onChange={handleOnChange}
                    name={name}
                    type="radio"
                    id={`section${index + 1}_${id}`}
                    checked={patientMedicationInfo[name] === cur}
                  />
                  <label
                    htmlFor={`section${index + 1}_${id}`}
                    className="font-mainFont text-[#000] font-[400] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]"
                  >
                    {cur}
                  </label>
                </div>
              </>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const CommonBTNsWrapper = () => {
  return (
    <>
      <div className="flex justify-center items-center w-full overflow-hidden px-2">
        <button className="border border-secondaryColor text-secondaryColor font-mainFont font-[500] flex-1 py-2 rounded-s-full hover:bg-[#19cded] hover:text-white transition-all duration-150 ease-linear hover:border-[#19cded]">
          Helped Pain
        </button>
        <button className="border border-secondaryColor text-secondaryColor font-mainFont font-[500] flex-1 py-2 hover:bg-[#19cded] hover:text-white transition-all duration-150 ease-linear hover:border-[#19cded]">
          Worsened
        </button>
        <button className="border border-secondaryColor text-secondaryColor font-mainFont font-[500] flex-1 py-2 rounded-e-full hover:bg-[#19cded] hover:text-white transition-all duration-150 ease-linear hover:border-[#19cded]">
          No Change
        </button>
      </div>
    </>
  );
};
